import Cookies from 'js-cookie';
import Question from '@/models/question';
const passObj: { [name: string]: string } = { "3": "eh7qWqz8uyZHB9zVsHurEQa9BrJpMXkv", "33": "bdzUc5XqK4fNWU9n8KwaMQPQn5D7ZWTx", "2": "eh7qWqz8uyZHB9zVDburEQa9BrJpMXkv", "22": "bdzUc5XqK4fNWU9n8KwaMavftrD7ZWTx" }
export default class BasicUtil {

  public static getUrlParams() {
    const urls = location.pathname.split("?")
    if (urls.length == 0) return []
    const url = urls[0]
    const arr = url.split("/")
    let first = ""
    let second = ""
    let third = ""
    let forth = ""
    if (arr.length > 1) first = arr[1]
    if (arr.length > 2) second = arr[2]
    if (arr.length > 3) third = arr[3]
    if (arr.length > 4) forth = arr[4]
    return [first, second, third, forth]
  }

  public static getQueryParams(): { [s: string]: string } {
    var queryString = window.location.search;
    var queryObject: { [s: string]: string } = {};
    if (queryString) {
      queryString = queryString.substring(1);
      var parameters = queryString.split('&');

      for (var i = 0; i < parameters.length; i++) {
        var element = parameters[i].split('=');

        var paramName = decodeURIComponent(element[0]);
        var paramValue = decodeURIComponent(element[1]);

        queryObject[paramName] = paramValue;
      }
    }
    return queryObject;
  }



  /**
   * クエリ ?allcorrect=true が付与されていれば全問正解モード。
   * 一度検知したらセッション中は有効（sessionStorage に保持）。
   */
  public static isAllCorrect(): boolean {
    return sessionStorage.getItem('allcorrect') === 'true' ||
      BasicUtil.getQueryParams()['allcorrect'] === 'true'
  }

  /**
   * すべての設問に正解を流し込み、正解入力状態（採点で満点）にする。
   * inputType ごとに、各問題ビューが正解入力時に行う処理を再現する。
   */
  public static fillCorrectAnswers(questions: Question[]) {
    for (const q of questions) {
      const type = q.inputType
      if (type === 1 || type === 2 || type === 3 || type === 4) {
        // 単一選択（choice / choiceDouble / choiceDouble2）
        q.currentChoice = Number(q.answer)
        q.result = true
      } else if (type === 5 || type === 8) {
        // 数値入力（halfText / halfText2）answer はカンマ区切りの数値
        const answers = String(q.answer).split(",")
        q.currentChoiceArr = [...answers]
        q.results = answers.map(() => true)
      } else if (type === 6 || type === 9) {
        // ○×（multipleMarubatsu / multipleMarubatsu2）answer は "1"=○ / "2"=×
        const answers = String(q.answer).split(",")
        q.currentChoiceArr = [...answers]
        q.results = answers.map(() => true)
      } else if (type === 7) {
        // 語句選択（multipleSelect）answer は選択肢の先頭文字
        const answers = String(q.answer).split(",")
        const options = String(q.choice1).split("|")
        q.currentChoiceArr = answers.map(a => {
          const hit = options.find(opt => opt.trim().charAt(0) === a.trim().charAt(0))
          return hit ?? a
        })
        q.results = answers.map(() => true)
      } else if (type === 10) {
        // 語句選択（multipleSelect2）answer は選択肢と完全一致
        const answers = String(q.answer).split(",")
        const options = String(q.choice1).split("|")
        q.currentChoiceArr = answers.map(a => {
          const hit = options.find(opt => opt.trim() === a.trim())
          return hit ?? a
        })
        q.results = answers.map(() => true)
      }
    }
  }

  public static isAllow() {
    try {
      localStorage.test = 'app';
      return true
    } catch (e) {
      return false
    }
  }

  public static getSc() {
    var CryptoJS = require('crypto-js');
    var key = CryptoJS.enc.Utf8.parse('EDbgnrs7Skn9MAsGjB9AnrwjENNbYyvi');
    var iv = CryptoJS.enc.Utf8.parse('8137249822330635');
    var dateTime = new Date().toUTCString()
    var srcs = CryptoJS.enc.Utf8.parse(dateTime);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.ciphertext.toString();
  }

  public setBasicSetting() {
    window.addEventListener("popstate", this.reload);
  }

  reload() {
    if (confirm("すべての解答がクリアされます。")) {
      location.href = "/"
    }
  }


  public removeBasicSetting() {
    window.onbeforeunload = null
    window.removeEventListener("popstate", this.reload);
  }

  public static onlyNumber(val: string): string {
    if (val.length == 0 || val == "") return "";
    val = val.replace(/,/g, '');
    val = val.replace(/０/g, '0');
    val = val.replace(/１/g, '1');
    val = val.replace(/２/g, '2');
    val = val.replace(/３/g, '3');
    val = val.replace(/４/g, '4');
    val = val.replace(/５/g, '5');
    val = val.replace(/６/g, '6');
    val = val.replace(/７/g, '7');
    val = val.replace(/８/g, '8');
    val = val.replace(/９/g, '9');
    if (/[^\-\.0-9]+/.test(val)) return "";
    return Number(val).toLocaleString()
  }

  public static zentoHanNumber(val: string): string {
    if (val.length == 0 || val == "") return "";
    val = val.replace(/０/g, '0');
    val = val.replace(/１/g, '1');
    val = val.replace(/２/g, '2');
    val = val.replace(/３/g, '3');
    val = val.replace(/４/g, '4');
    val = val.replace(/５/g, '5');
    val = val.replace(/６/g, '6');
    val = val.replace(/７/g, '7');
    val = val.replace(/８/g, '8');
    val = val.replace(/９/g, '9');
    if (/[^\-\.0-9]+/.test(val)) return "";
    return val
  }

  public static justifyText(text: string) {
    if (text.indexOf('<span>') !== -1) {
      return text
    }
    const letters: string[] = []
    let isB: boolean = false
    text.split('').forEach((t: string) => {
      if (t == ")") isB = false
      if (isB) {
        letters.push("<span><b>" + t + "</b></span>")
      } else {
        letters.push("<span>" + t + "</span>")
      }
      if (t == "(") isB = true
    })
    return letters.join("")
  }

  public static arrayShuffle(array: any) {
    for (var i = (array.length - 1); 0 < i; i--) {

      var r = Math.floor(Math.random() * (i + 1));

      var tmp = array[i];
      array[i] = array[r];
      array[r] = tmp;
    }
    return array;
  }

  public static setGradePass(grade: string): void {
    Cookies.set('tac-cbt-fp-' + grade, passObj[grade], { expires: 365 });
  }

  public static isAuth(grade: string): boolean {
    if (grade == '0') return true
    const cookie = Cookies.get('tac-cbt-fp-' + grade)
    return cookie !== undefined && cookie == passObj[grade]
  }

  public static getQa3() {
    const qas = [

      "260611600",
"250511601",
"250511605",
"250511393",
"270612080",
"260512081",
"260512085",
"260512109"
    ]
    return qas;
  }

  public static getQa33() {
    const qas = [

      "250611608",
"250511609",
"260511612",
"250511623",
"250511624",
"260612088",
"260512090",
"260512093",
"260512096",
"260512098"
    ]
    return qas;
  }

  public static getQa2() {
    return [
      "250111389",
      "250511602",
"250511606",
"250611394",
"260512082",
"260512086",
"260512110"
    ]
  }

  public static getQa22() {
    return [
      "250611627",
"250511610",
"250511613",
"260511613",
"250511625",
"250511626",
"260612089",
"260512097",
"260512099",
"260512091",
"260512094"
    ]
  }

  public static getTitleFromType(type: number, grade: number) {
    if (grade == 3 || grade == 33) {
      switch (type) {
      case 0:
        return "チュートリアル";
      case 1:
        return "学科試験";
      case 2:
        return "実技試験　個人資産相談業務";
      case 3:
        return "保険顧客資産相談業務";
      case 4:
        return "実技試験　資産設計提案業務";
      default:
        return "";
    }
    }
    else {
      switch (type) {
      case 0:
        return "チュートリアル";
      case 1:
        return "学科試験";
      case 2:
        return "実技試験　個人資産相談業務";
      case 3:
        return "生保顧客資産相談業務";
      case 4:
        return "実技試験　資産設計提案業務";
      default:
        return "";
    }
    }
    
    return "";
  }
  public static getBasicInfoFromType(type: number, grade: number) {
    if (grade == 3 || grade == 33) {
      switch (type) {
        case 0:
          return { time: "3", num: "2" };
        case 1:
          return { time: "90", num: "60" };
        case 2:
          return { time: "60", num: "15" };
        case 3:
          return { time: "60", num: "15" };
        case 4:
          return { time: "60", num: "20" };
        default:
          return { time: "90", num: "60" };
      }
    } else {
      switch (type) {
        case 0:
          return { time: "3", num: "2" };
        case 1:
          return { time: "120", num: "60" };
        case 2:
          return { time: "90", num: "15" };
        case 3:
          return { time: "90", num: "15" };
        case 4:
          return { time: "90", num: "40" };
        default:
          return { time: "90", num: "60" };
      }
    }

    return { time: "120", num: "60" };
  }

  public onlyNumberMinus(val: string): string {
    if (val.length == 0 || val == "") return "";
    if (/[^0-9.-]/.test(val) || (val.match(/\./g) || []).length > 1 || (val.match(/-/g) || []).length > 1) return "";
    return Number(val).toLocaleString()
  }
}
